<template>
    <div>
        <filter-reports @generate-report="clickGenerate" v-if="showFilters"
            name-report="Reporte de Solicitudes Procesadas" />
        <CRow class="justify-content-center" v-if="showReport">
            <CCol md="12">
                <CCard>
                    <CCardHeader style="background: #97ca3d;color: #000000;">
                        <h4>Reporte de Solicitudes Procesadas</h4>
                    </CCardHeader>
                    <CCardBody>
                        <table-for-reports :fields-table="fieldsTableReport"
                            :table="tableForReport" :total-rows="totalRows" />
                        <CRow class="content-center">
                            <CCol sm="6">
                                <export-excel :data-to-export="dataToExport"
                                    file-name="Reporte Solicitudes Procesadas" />
                            </CCol>
                            <CCol sm="6">
                                <b-button @click="generateNewReport" style="margin-top: 10px;" pill variant="success">
                                    Generar Otro Reporte</b-button>
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
    import FilterReports from '../../components/filterReports'
    import functionsReports from '../../functions/functionsForReports'
    import exportExcel from '../../components/exportExcel'
    import tableForReports from '../../components/tableForReports'
    /*Componente para el reporte de solicitudes procesadas  */
    export default {
        name: 'reportRequestsProcessed',
        title: 'Reporte Solicitudes Procesadas | Infoguia',
        components: {
            FilterReports,
            exportExcel,
            tableForReports
        },
        data() {
            return {
                showFilters: true,
                showReport: false,
                //dataForPost: null
                fieldsTableReport: [{
                        key: 'name',
                        label: 'Nombre Usuario'
                    },
                    {
                        key: 'requestsProcess',
                        label: 'Solicitudes Procesadas',
                        tdClass: 'content-right',
                    },
                    {
                        key: 'requestsReject',
                        label: 'Solicitudes Rechazadas',
                        tdClass: 'content-right',
                    },
                ],
                tableForReport: [],
                dataToExport: [],
                totalRows: 0,
            }
        },
        methods: {
            clickGenerate(dataForPost) {
                this.loadReport(dataForPost)
            },
            loadReport(dataForPost) {
                let loader = this.$loading.show()
                functionsReports.getReportProcessedRequest(dataForPost).then(response => {
                    this.totalRows = response.length
                    for (let index = 0; index < response.length; index++) {
                        this.tableForReport[index] = {
                            'name': response[index].name,
                            'requestsProcess': response[index].requestsProcess,
                            'requestsReject': response[index].requestsReject,
                            'idUser': response[index].idUsers,
                            '_rowVariant': '',
                        }
                        this.dataToExport[index] = {
                            'Usuario': response[index].name,
                            'Solicitudes Procesadas': response[index].requestsProcess,
                            'Solicitudes Rechazadas': response[index].requestsReject,
                        }
                    }
                    if (this.tableForReport.length > 0) {
                        this.showReport = true
                        this.showFilters = false
                    }
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                    loader.hide()
                })
            },
            generateNewReport() {
                this.showReport = false
                this.showFilters = true
                this.tableForReport = []
            },
        }
    }
</script>